var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height"},[_c('v-row',{staticClass:"text-center"},[_c('v-col',{attrs:{"cols":"12"}},[_vm._v(" Redirecting... ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }